<template>
  <v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container fluid fill-height align-start>
        <v-row>
          <v-col md="12" sm="12" lg="12" cols="12">
            <v-autocomplete v-model="eventoId" :items="eventos" item-text="nombre" item-value="id"  label="Escoger Evento">
            </v-autocomplete>
          </v-col>
        </v-row>
      <v-row>
        <v-col md="12" sm="12" lg="12" cols="12">
        <v-card :color="color">
          <v-card-title>
            Leer QR
          </v-card-title>
          <v-card-text >
            <p class="decode-result" style="color:white; background-color: black;">{{ result }}</p>
            <p class="decode-result" style="color:white; background-color: black;">{{ nombre }}</p>
            <p class="decode-result" style="color:white; background-color: black;">{{ dni }}</p>

            <p class="decode-result" style="color:white; background-color: black;">{{ evento }} - {{ zona }} - {{ entrada }} </p>
            <p class="error">{{ error }}</p>


            <qrcode-stream  @decode="onDecode" @init="onInit">
            </qrcode-stream>
          </v-card-text>
        </v-card>
      </v-col>
      </v-row>
        <leftmenueventos />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>

import Leftmenueventos from "@/components/general/leftmenueventos";
import axios from "axios";
import {mapGetters} from "vuex";
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: "LeeQREv",
  components: {
    Cabecerabaja,
    Leftmenueventos
  },
  data() {
    return {
      camera: 'auto',
      result: null,
      error: '',
      color: 'black',
      nombre:'',
      dni:'',
      eventoId:0,
      eventos:[],
      evento:'',
      entrada:'',
      zona:'',
      overlay:false,
     showScanConfirmation: false
    }
  },
  mounted (){

    if (this.usuario.id === undefined){

      this.$router.push({ path: '/' });
    }else{
      this.dameEventos();      }
  },
  methods: {

    dameEventos(){
      let urltempor = 'eventos/cliente/' + this.cliente.id  ;
      this.overlay = true

      axios
          .get(urltempor)
          .then(response => {
            this.eventos = response.data;
            this.eventoId = this.eventos[0].id
            this.overlay = false

          })
          .catch((error)  => {
            this.error = error
            this.overlay = false

          });
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        } else if (error.name === 'InsecureContextError') {
          this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
        } else {
          this.error = `ERROR: Camera error (${error.name})`;
        }
      }
    },

    async onDecode (content) {
      var bodyFormData = new FormData();
      bodyFormData.append("codigoUnico",content);
      bodyFormData.append("eventoId",this.eventoId);
      let url = "tickets/qrcode"
      this.overlay = true
      axios
          .post(url,bodyFormData)
          .then(response => {
            this.result = response.data.ingresado
            this.color = response.data.color
            this.nombre = 'Nombre: '+ response.data.nombre
            this.dni = 'DNI: '+ response.data.dni
            this.evento= 'Evento '+ response.data.evento
            this.zona = 'Zona '+ response.data.zona
            this.entrada = 'Entrada ' + response.data.entrada
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false
            console.log(error);
          });
      this.pause()
      await this.timeout(500)
      this.unpause()
    },

    unpause () {
      this.camera = 'auto'
    },

    pause () {
      this.camera = 'off'
    },

    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente:"cliente"
    })
  }
}
</script>